import styled from 'styled-components';

import type { Variant } from './ThresholdArea';

const colors: Record<Variant, string> = {
  bullish: 'var(--viz-bullish)',
  bearish: 'var(--viz-bearish)',
};

export const AreaRect = styled.rect<{
  variant: Variant;
  showEdgeLine?: boolean;
}>`
  fill: ${({ variant }) => colors[variant]};
  stroke: ${({ variant }) => colors[variant]};
  stroke-width: ${({ showEdgeLine }) => (showEdgeLine ? 2 : 0)};
  mix-blend-mode: darken;

  // Safari iOS (mobile) doesn't support mix-blend-mode on SVG elements
  // https://stackoverflow.com/questions/30102792/css-media-query-to-target-only-ios-devices
  @supports (-webkit-touch-callout: none) {
    display: none;
  }
`;

export const EdgeLine = styled.line<{ variant: Variant }>`
  stroke: ${({ variant }) => colors[variant]};
  stroke-width: 1;
  stroke-dasharray: 3;
`;
